import type { ReactElement } from "react";
import { IconProps, SvgIcon } from "./SvgIcon";

export function GearsIcon({ className, size }: IconProps): ReactElement {
  return (
    <SvgIcon size={size} className={className} viewBox="0 0 64 64">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.28 41.8372H10.163L10.163 34.721L4 31.163L7.55812 25.0003L4.00011 18.8378L10.1634 15.2795L10.1634 8.16418L17.278 8.16417L20.837 2L27.0022 5.55934L33.163 2.00248L36.7208 8.1644L43.8375 8.1644L43.8375 15.2798L50 18.8377L46.4417 25.0006L49.9996 31.1628L43.8371 34.7207L43.8371 41.8374L36.7212 41.8374L33.1628 48.0006L26.9978 44.4414L20.8372 47.9981L17.28 41.8372ZM26.9995 31.3157C30.4866 31.3157 33.3134 28.4889 33.3134 25.002C33.3134 21.515 30.4866 18.6883 26.9995 18.6883C23.5125 18.6883 20.6856 21.515 20.6856 25.002C20.6856 28.4889 23.5125 31.3157 26.9995 31.3157Z"
        fill="#7661C9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M44.3518 59.0519H40.9472L40.9472 55.6487L38.0001 53.9475L39.7017 51.0006L38 48.0535L40.9475 46.352L40.9475 42.9492L44.3492 42.9492L46.0522 40L49.0033 41.7035L51.9476 40.0039L53.648 42.9486L57.0526 42.9486L57.0526 46.3508L60 48.0522L58.2983 50.9991L60 53.9461L57.0525 55.6476L57.0525 59.0513L53.6501 59.0513L51.9471 62.0005L48.9962 60.2971L46.0522 61.9966L44.3518 59.0519ZM48.9998 54.0188C50.6676 54.0188 52.0195 52.6671 52.0195 50.9996C52.0195 49.3321 50.6676 47.9803 48.9998 47.9803C47.3321 47.9803 45.9801 49.3321 45.9801 50.9996C45.9801 52.6671 47.3321 54.0188 48.9998 54.0188Z"
        fill="#FFB9A5"
      />
    </SvgIcon>
  );
}
